export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-pt-BR.01d8107f.xlsx";